import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import ReviewDate from './ReviewDate';
import { Rating } from './Rating';
import { Source } from './Source';
import { ReviewContent } from './ReviewContent';
import ReviewReply from './ReviewReply';

export const ReviewModal = ({
	show,
	closeModal,
	author,
	rating,
	source,
	singleSource,
	reviewDate,
	content,
	labels,
	fontSize,
	reviewDateFontSize,
	showReply,
	replyData
}) => {
	const shouldRenderReply = showReply && replyData;

	const modalCloseBtnRef = useRef(null);

	const closeModalOnEscKeyDown = (e) => {
		if (show && e.which === 27) {
			closeModal();
			e.stopPropagation();
		}
	};

	const handleOnBlur = (e) => {
		e.preventDefault();

		if (modalCloseBtnRef.current === e.target) {
			modalCloseBtnRef.current.focus();
		}
	};

	return (
		<Modal
			show={show}
			onBlur={handleOnBlur}
			onKeyDown={closeModalOnEscKeyDown}
			onHide={() => closeModal()}
		>
			<Modal.Header>
				<div className="d-flex justify-content-between">
					<Modal.Title className="d-flex align-items-center flex-wrap mr-4 overflow-hidden">
						<p className="m-0 mr-3">{author}</p>
						{!singleSource && (
							<Source
								source={source}
								singleSource={singleSource}
							/>
						)}
					</Modal.Title>
					<button
						type="button"
						aria-label="Close"
						className="btn-unstyled"
						onClick={closeModal}
						ref={modalCloseBtnRef}
					>
						<i
							className="ddc-icon ddc-icon-close"
							aria-hidden="true"
						/>
					</button>
				</div>
				<Rating
					rating={rating}
					source={source}
					labels={labels}
					fontSize={fontSize}
				/>
				<ReviewDate
					reviewDate={reviewDate}
					fontSize={reviewDateFontSize}
				/>
			</Modal.Header>
			<Modal.Body>
				<ReviewContent
					truncate={false}
					fontSize={fontSize}
					content={content}
					autoFocus
				/>
				{shouldRenderReply && (
					<ReviewReply
						reply={replyData.content}
						replyDate={replyData.publishedOn}
						replyDateFontSize={reviewDateFontSize}
						replyFontSize={fontSize}
					/>
				)}
			</Modal.Body>
		</Modal>
	);
};

ReviewModal.propTypes = {
	show: PropTypes.bool.isRequired,
	closeModal: PropTypes.func.isRequired,
	author: PropTypes.string.isRequired,
	rating: PropTypes.number.isRequired,
	source: PropTypes.string.isRequired,
	singleSource: PropTypes.bool.isRequired,
	reviewDate: PropTypes.string.isRequired,
	content: PropTypes.string.isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func
	}).isRequired,
	fontSize: PropTypes.string,
	reviewDateFontSize: PropTypes.string,
	showReply: PropTypes.bool,
	replyData: PropTypes.shape({
		author: PropTypes.string,
		content: PropTypes.string,
		publishedOn: PropTypes.string
	})
};

ReviewModal.defaultProps = {
	fontSize: '',
	reviewDateFontSize: ''
};
